import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { Button } from "./Button";
const HeroSection = ({ Data }) => {
  const { name } = Data;
  return (
    <Wraper>
      <div className="container">
        <div className="grid grid-two-column">
          <div className="hero-section--data">
            <p className="intro-data"> {name}</p>
            <h2>selony</h2>
            <p>
              lorem ipsum hdfeuss jd erc ndkekd jdjdbwdjdnnbjcb jhhfcd bscbc
              paragraph is defined as “a group of sentences or a single sentence
              that forms a unit” (Lunsford and Connors 116). Length and
              appearance
            </p>
            <NavLink>
              <Button>show me</Button>
            </NavLink>
          </div>
          <div className="hero-section--image">
            <figure>
              <img
                src="./image/hero-img.jpg"
                alt="hero-img"
                className="hero-img"
              />
            </figure>
          </div>
        </div>
      </div>
    </Wraper>
  );
};
const Wraper = styled.section`
  padding: 12rem 0;
  img {
    min-width: 12rem;
    height: 10rem;
  }
  .hero-section-data {
    p {
      margin: 2rem 0;
    }
    .intro-data {
      margin-bottom: 0;
    }
  }
  .hero-section-image {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  figure {
    position: relative;
    &::after {
      content: "";
      width: 60%;
      height: 80%;

      background-color: rgba(81, 56, 238, 0.4);
      position: absolute;
      left: 50%;
      top: -4rem;
      z-index: -1;
    }
    .hero-img {
      width: 100%;
      height: auto;
    }
  }
  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    .grid {
      gap: 10rem;
    }

    figure::after {
      content: "";

      width: 50%;
      height: 100%;
      left: 0;
      top: 10%;
      /* bottom: 10%; */
      background-color: rgba(81, 56, 238, 0.4);
    }
  }
`;
export default HeroSection;
